import React from "react";
import {
    Box,
    Grid
} from "@mui/material";
import DataFields from "../../../Components/DataFields";
import { tryFormatMoney } from "../../../Helpers";
import C170DetailsData from "./C170DetailsData";
import C190DetailsData from "./C190DetailsData";

interface ICardsNFEDetailsDataProps {
    data: any;
}

const CardsNFEDetailsData: React.FC<ICardsNFEDetailsDataProps> = ({
            data: {
                data = {},
                c170 = [],
                c190 = []
            }
    }) => {
       
        const {
            ind_oper = '',
            ind_emit = '',
            cod_part = '',
            cod_mod = '',
            serie = '',
            num_doc = 0,
            chv_nfe = 0,
            dt_emissao = '',
            dt_entrada_saida = '',
            vl_doc = '',
            ind_pgto = '',
            vl_desc = '',
            vl_abat_nt = '',
            vl_merc = '',
            ind_frete = '',
            vl_frete = '',
            vl_seg = '',
            vl_out_da = '',
            vl_bc_icms = '',
            vl_icms = '',
            vl_bc_icms_st = '',
            vl_icms_st = '',
            vl_ipi = '',
            vl_pis = '',
            vl_cofins = '',
            vl_pis_st = '',
            vl_cofins_st = '',
        } = data;

    return (<Box sx={{ mb: 3, width: '100%' }}>
        <Grid container spacing={0.5}>
            <Grid item xs={12}>
                <Grid container spacing={0.5}>
                    <DataFields 
                        data={[
                            {label: 'Tipo de Operação', value: ind_oper},
                            {label: 'Emitente', value: ind_emit},
                            {label: 'Código do Participante', value: cod_part},
                            {label: 'Modelo', value: cod_mod},
                            {label: 'Série', value: serie},
                            {label: 'Número Documento', value: num_doc},
                            {label: 'Chave', value: chv_nfe},
                            {label: 'Data de emissão', value: dt_emissao},
                            {label: 'Data de Entrada/Saída', value: dt_entrada_saida},
                            {label: 'Valor Do Documento', value: tryFormatMoney(vl_doc)},
                            {label: 'Indicador de Pagamento', value: ind_pgto},
                            {label: 'Valor do Desconto', value: tryFormatMoney(vl_desc)},
                            {label: 'Valor do Abatimento não Tributado', value: tryFormatMoney(vl_abat_nt)},
                            {label: 'Valor das mercadorias', value: tryFormatMoney(vl_merc)},
                            {label: 'Tipo de Frete', value: ind_frete},
                            {label: 'Valor do Frete', value: tryFormatMoney(vl_frete)},
                            {label: 'Valor do Seguro', value: tryFormatMoney(vl_seg)},
                            {label: 'Valor de outras despesas', value: tryFormatMoney(vl_out_da)},
                            {label: 'Valor da base de cálculo do ICMS', value: tryFormatMoney(vl_bc_icms)},
                            {label: 'Valor do ICMS', value: tryFormatMoney(vl_icms)},
                            {label: 'Valor da base de cálculo do ICMS ST', value: tryFormatMoney(vl_bc_icms_st)},
                            {label: 'Valor do ICMS ST', value: tryFormatMoney(vl_icms_st)},
                            {label: 'Valor do IPI', value: tryFormatMoney(vl_ipi)},
                            {label: 'Valor do PIS', value: tryFormatMoney(vl_pis)},
                            {label: 'Valor do COFINS', value: tryFormatMoney(vl_cofins)},
                            {label: 'Valor do PIS ST', value: tryFormatMoney(vl_pis_st)},
                            {label: 'Valor do COFINS ST', value: tryFormatMoney(vl_cofins_st)}
                        ]}
                        xs={12}
                        sm={6}
                        md={4}
                    />
                </Grid>
            </Grid>
            {
                c170 &&
                Array.isArray(c170) &&
                <C170DetailsData c170={c170}/>
            }
            {
                c190 &&
                Array.isArray(c190) &&
                <C190DetailsData c190={c190}/>
            }
        </Grid>
    </Box>);
}

export default CardsNFEDetailsData;